import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PrivacySettingsPage } from "@/features/collector-profile/components/privacy-settings-page";
import { useI18n } from "@/providers/i18n-provider";

// Sub-ruta del perfil (Wave 1 · W1-PROFILE) — configuración de privacidad del
// perfil del coleccionista. Traducción del diseño `configurar_privacidad_de_perfil`.
function JournalPrivacyRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Privacidad del perfil`)}
      description={t(
        msg`Inicia sesión para configurar quién ve tu colección, tus deseos y tus publicaciones.`,
      )}
    >
      <PrivacySettingsPage />
    </AuthPlaceholder>
  );
}

export const journalPrivacyRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/journal/privacy",
  component: JournalPrivacyRoutePage,
});
